import React from 'react';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';

import { Select, DatePicker } from 'ui/components';
import { formatDate } from 'utilities/common';

const statusOptions = [
  { value: 'new', label: 'Baru' },
  { value: 'completed', label: 'Complete' },
];

const initialState = {
  document_status: null,
  schedule_at: null,
};

const Filter = ({ show, onClose, table, setCount }) => {
  const [{ document_status, schedule_at }, setState] = React.useState(initialState);

  const $onLoad = async () => {
    let sd = null
    if (table.State?.filter?.schedule_at) {
      sd = new Date(table.State?.filter?.schedule_at)
    }

    setState((prevState) => ({
      ...prevState,
      schedule_at: sd,
      document_status:
        table?.State?.filter?.document_status === 'new'
          ? statusOptions[0]
          : table?.State?.filter?.document_status === 'completed'
          ? statusOptions[2]
          : null,
    }));
  };

  const handleFilter = async (e) => {
    if (table?.State?.filter) {
      let x = [];
      Object.keys(table?.State?.filter).forEach((k) => {
        if (
          table?.State?.filter[k] &&
          k !== 'start_at' &&
          k !== 'warehouse_id'
        ) {
          x.push(k);
        }
      });

      setCount(x);
    }
  };

  const $handleStatus = (e) => {
    setState((prevState) => ({
      ...prevState,
      document_status: e,
    }));
    table.filter('document_status', e?.value);
    handleFilter();
  };

  const $handleScheduleAt = (e) => {
    let filterDate = null
    if (e) {
      filterDate = formatDate(e, 'YYYY-MM-DD')
    }

    setState((prevState) => ({
      ...prevState,
      schedule_at: e,
    }));
    table.filter('schedule_at', filterDate);
    handleFilter();
  };

  React.useEffect(() => {
    $onLoad();
  }, []);

  React.useEffect(() => {
    handleFilter();
  }, []);

  return (
    <>
      <div
        className={cn(
          show
            ? 'col-md-3 d-none d-md-block py-3 px-3 m-0 border-start'
            : 'd-none'
        )}
      >
        <div className="mb-3 border-bottom">
          <div className="d-flex align-items-center justify-content-between">
            <div className="page-pretitle fs-7 text-secondary">Filter</div>
            <div className="mt-n1">
              <button className="btn btn-action-close " onClick={onClose}>
                <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
              </button>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">
            Jadwal Kedatangan
          </div>
          <DatePicker
            value={schedule_at}
            placeholder=""
            onChange={$handleScheduleAt}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">
            Status Penerimaan
          </div>
          <Select
            placeholder=""
            classNamePrefix="select"
            isClearable
            options={statusOptions}
            value={document_status}
            onChange={$handleStatus}
          />
        </div>
      </div>

      <>
        <div
          className={cn('filter-overlay', show ? 'd-block d-md-none' : '')}
          onClick={onClose}
        />
        <div
          className={cn(
            'filter-modal d-block d-md-none py-3',
            show ? 'filter-show' : ''
          )}
        >
          <div className="mb-3 border-bottom">
            <div className="d-flex align-items-center justify-content-between">
              <div className="page-pretitle fs-7 text-secondary">Filter</div>
              <div className="mt-n1">
                <button className="btn btn-action-close " onClick={onClose}>
                  <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
                </button>
              </div>
            </div>
          </div>

           <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">
              Jadwal Kedatangan
            </div>
            <DatePicker
              value={schedule_at}
              placeholder=""
              onChange={$handleScheduleAt}
            />
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">
              Status Penerimaan
            </div>
            <Select
              placeholder=""
              classNamePrefix="select"
              isClearable
              options={statusOptions}
              value={document_status}
              onChange={$handleStatus}
            />
          </div>
        </div>
      </>
    </>
  );
};

export default Filter;
